export default __webpack_public_path__ + "static/media/community-manager.b320edfa.jpg";